import { render, staticRenderFns } from "./invoicesForm.vue?vue&type=template&id=22b71750&scoped=true"
import script from "./invoicesForm.vue?vue&type=script&lang=js"
export * from "./invoicesForm.vue?vue&type=script&lang=js"
import style0 from "./invoicesForm.vue?vue&type=style&index=0&id=22b71750&prod&scoped=true&lang=stylus"
import style1 from "./invoicesForm.vue?vue&type=style&index=1&id=22b71750&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b71750",
  null
  
)

export default component.exports